import React, {useEffect} from 'react';
import List from "@mui/material/List";
import MessageItem from "./MessageItem";
import messages from "./fake-data";
import {listmessage} from "../../../../api/api";

const MessagesList = ({settingMenuCallback,result}) => {
    // const [Loader, setLoader] = React.useState(true);
    // const [result, setResult] = React.useState([]);
    //
    // useEffect(() => {
    //         listmessage()
    //             .then((response) => {
    //                 setResult(response.data.list)
    //                 setLoader(false)
    //
    //             })
    //             .catch((error) => {
    //                 setLoader(false)
    //             });
    //
    //     }, []);


    return (
        <List disablePadding>
            {result.map((item, index) => {
                    return (
                        <MessageItem settingMenuCallback={settingMenuCallback} key={index} item={item}/>
                    )
                })}
        </List>
    );
};

export default MessagesList;
